import { fill, isObject } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

// Format [value, times], ...
// return Array
export const makeLine = (...pairs) => pairs.reduce((acc, pair) => (isObject(pair) && pair !== null && pair.length ? [...acc, ...fill(Array(pair[1]), pair[0])] : [...acc, pair]), []);

export const makeCharger = (plazaUuid, chargerName, chargerUuid) => ({
  chargerUuid: chargerUuid || uuidv4(),
  plazaUuid,
  chargerName,
});

export const makeEvent = (charger, eventType, values) => ({
  uuid: uuidv4(),
  plazaEventType: eventType,
  values: values || {},
  ...charger,
});

export function* eventGenerator(events) {
  for (let i = 0; true; i++) {
    if (i === events.length) i = 0;
    yield events[i];
  }
}

export function* sourceGenerator(sources) {
  const nodeKeys = Object.keys(sources);
  const nodeAttrs = Object.keys(sources[nodeKeys[0]]);
  const stepCount = sources[nodeKeys[0]][nodeAttrs[0]].length;

  for (let i = 0; true; i++) {
    if (i === stepCount) i = 0;

    const result = {};

    nodeKeys.forEach((nodeKey) => {
      const nodeAttrs = Object.keys(sources[nodeKey]);

      nodeAttrs.forEach(
        (attr) => {
          if (!result[nodeKey]) result[nodeKey] = {};
          result[nodeKey][attr] = sources[nodeKey][attr][i];
        },
      );
    });

    yield result;
  }
}

export function* widgetDataGenerator(widgets) {
  const widgetKeys = Object.keys(widgets);
  const firstWidget = Object.keys(widgets[widgetKeys[0]]);
  const stepCount = firstWidget.length;

  for (let i = 0; true; i++) {
    if (i === stepCount) i = 0;
    yield widgetKeys.reduce((acc, key) => {
      acc[key] = widgets[key][i];

      return acc;
    }, {});
  }
}

export const detectDemoMode = () => window.location.search.slice(1);
